import { AlertMessageKind } from "client/Components";
import { EMPTY_ARRAY } from "client/Misc/utils";

const storageKey = "alertMessages";

export function pushMessage(message: AlertMessage): void {
	const currentMessages: readonly AlertMessage[] = getMessages();

	setMessages([
		...currentMessages,
		message
	]);
}

export function popAllMessages(): readonly AlertMessage[] {
	const messages: readonly AlertMessage[] = getMessages();

	clearMessages();

	return messages;
}

function getMessages(): readonly AlertMessage[] {
	const serializedMessages: string | null = sessionStorage.getItem(storageKey);

	if (!serializedMessages) {
		return EMPTY_ARRAY;
	}

	try {
		return JSON.parse(serializedMessages);
	} catch(e) {
		console.error("Unable to deserialize stored messages", e);
		return EMPTY_ARRAY;
	}
}

function setMessages(messages: readonly AlertMessage[]): void {
	if (messages.length === 0) {
		clearMessages();
		return;
	}

	sessionStorage.setItem(storageKey, JSON.stringify(messages));
}

function clearMessages(): void {
	sessionStorage.removeItem(storageKey);
}

export type AlertMessage = {
	text: string;
	type: AlertMessageKind;
};